define('superAdminAccountGraphView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'moment',
  'chartView'
], function (
  module,
  Marionette,
  _,
  App,
  moment,
  ChartView
) {
  'use strict';

  var SuperAdminGraphView =  ChartView.extend({
    serializeData: function() {
      var that = this, 
        tplData = this.model.toJSON(),
        labels = [],
        dataCreated = [],
        dataTotal = [];

      if ( !_.isUndefined(tplData) && !_.isEmpty(tplData)) {
        _.each(tplData, function(item) {
          if (that.options.filters.type === 'Month') {
            labels.push(moment(item.date).format('MMMM'));
          } else if (that.options.filters.type === 'Day') {
            labels.push(moment(item.date).format('DD/MM/YYYY'));
          } else if (that.options.filters.type === 'Week') {
            labels.push(moment(item.date).format('W'));
          } else if (that.options.filters.type === 'Year') {
            labels.push(moment(item.date).format('YYYY'));
          }
          dataCreated.push(item.created);
          dataTotal.push(item.total);
        });

        this.data = {
          labels : labels,
          datasets : [
            {
              label: _.i18n('superAdmin.accounts.created'),
              backgroundColor : 'rgba(0, 190, 164, 0.10)',
              borderColor : 'rgba(0, 190, 164, 1)',
              pointColor : 'rgba(0, 190, 164, 1)',
              pointStrokeColor : '#fff',
              data : dataCreated
            },
            {
              label: _.i18n('superAdmin.accounts.total'),
              backgroundColor : 'rgba(226, 147, 239, 0.10)',
              borderColor : 'rgba(226, 147, 239, 1)',
              pointColor : 'rgba(226, 147, 239, 1)',
              pointStrokeColor : '#fff',
              data : dataTotal
            }
          ]
        };
      }
      this.generateLegend();
      return this.data;
    },

    generateLegend: function() {
      this.options.legend = '<ul class="legend-chart-view">' +
        '<li><span>' + _.i18n('superAdmin.period') + ': ' + this.options.filters.type + '</span></li></ul>';
    }
  });

  module.exports = SuperAdminGraphView;
});
